/* CRLF -> LF */
const phrases = {
	fromDateIsMandatory: 'From date is mandatory',
	lock: 'Lock',
	LabelAdmin: 'Label administration',
	reallyLockLabels: '',
	reallyUnlockLabels: '',
	reallySetNextLabelYear: '',
	unlockWoChangingDistPeriod: 'Unlock wo changing dist. period',
	setNextLabelYear: 'Set current label distribution period to $year',
	labelModuleLockedMessage: 'Labels for $year are being processed by Intergram. In the meantime they are read-only.',
	labelDetail: 'Label detail',
	labelDetailSubheader: 'If you only own the label for a part of the year specify the date range. If you do not own the label anymore check "$labelIsDeleted" please.',
	newLabelDetailSubheader: 'If you only own the label for a part of the year specify the date range.',
	labelIsDeletedMessage: 'I am not claiming the label in $year',
	dateIsOutsideYear: 'Date must be in year $year',
	toDateIsLessThanFromDate: 'To date must not be less than from date',
	labelNameIsMandatory: 'Label name is mandatory',
	duplicateLabelName: 'Label with this name already exists.',
	registeredLabelsForYear: 'Registered labels for $year',
	newLabel: 'New label',
	labelCount: 'Label count',
	openMatchedUserDetail: 'Open matched user detail',
	IsrcProtocol: 'Recording catalog',
	isrcDatabase: 'ISRC database',
	phoneHours: '(mon-fri 9:00 - 16:00, except public holidays)',
	invoiceDocumentsHeader: 'Invoice documentation (please issue invoice)',
	eloUnavailable: 'Documents are unavailable at the moment, try again later please.',
	Document: 'Invoices',
	payments: 'Payment',
	paidOn: 'Paid on',
	invoiceDocuments: 'Invoice documents',
	documentNoDataMessage: 'No documents available',
	otherInheritedRemuneration: 'other inherited remunerations',
	broadcasterNotSpecified: 'Broadcaster not specified',
	nRolesSelected1: '$count role selected',
	nRolesSelected2_4: '$count roles selected',
	nRolesSelected5_: '$count roles selected',
	inNProfiles1: 'in $count profile',
	inNProfiles2_4: 'in $count profiles',
	inNProfiles5_: 'in $count profiles',
	'roleLookup.profile.PRO': 'ensemble profile',
	'roleLookup.profile.PRO': 'producer profile',
	'roleLookup.profile.PER': 'performer profile',
	inheritedRights: 'inherited rights',
	ensembleShare: 'ensemble share',
	'dashboard.subHeader.country': 'Country',
	cmoRewards: 'Foreign remuneration',
	submissionMaxAttachmentSize: 'max. single file size $singleFileSizeLimit MB, all atachments $totalSizeLimit MB',
	affirmationCorrectionSubheader: 'If the displayed data is incorrect, please correct it and provide justification, including any attachments explaining the discrepancy, if applicable. Thank you.',
	'reallySavePermanentCatalogChanges': 'Do you really want to save the changes?', // Opravdu uložit provedené změny?
	'unprocessedSubmissionWithSameIsrcExists': 'A registration with the same ISRC is being processed.', // Existuje nezpracované podání se stejným ISRC.
	'duplicateIsrc': 'Duplicate ISRC', // Duplicitní ISRC
	'recordingProtocol.sameIsrcRecordingsWarningHeader': 'Previously submitted registrations with the same ISRC exist.', // Evidujeme dříve podané registrace se stejným ISRC
	'recordingProtocol.sameIsrcRecordingWarningHeader': 'A previously submitted registration with the same ISRC exists.', // Evidujeme dříve podanou registraci se stejným ISRC
	'catalog.sameIsrcRecordingsWarningHeader': 'Your producer catalog contains recordings with the same ISRC.', // Katalog nahrávek obsahuje nahrávky se stejným ISRC
	'catalog.sameIsrcRecordingWarningHeader': 'Your producer catalog contains a recording with the same ISRC.', // Katalog nahrávek obsahuje nahrávku se stejným ISRC
	'recordingProtocol.sameIsrcRecordingErrorHeader': 'A registration with the same ISRC is being processed.', // Evidujeme nezpracovanou registraci se stejným ISRC
	'recordingProtocol.sameIsrcRecordingsErrorHeader': 'Registrations with the same ISRC are being processed.', // Evidujeme nezpracované registrace se stejným ISRC
	'mdb.sameIsrcRecordingWarningHeader': 'You already have a recording with the same ISRC.', // Mezi vašimi nahrávkami se nachází nahrávka se stejným ISRC
	'mdb.sameIsrcRecordingsWarningHeader': 'You already have recordings with the same ISRC.', // Mezi vašimi nahrávkami se nachází nahrávky se stejným ISRC
	'mdb.adminSameIsrcRecordingWarningHeader': 'Master DB contains a recording with the same ISRC.', // V MDB evidujeme nahrávku se stejným ISRC
	'recordingProtocolMessage#validationErrors': 'Errors occurred during the processing of the registration', // Při zpracování došlo k chybám
	'recordingProtocolMessage#catalogProviderIsNotAProducer': 'The producer is not registered as a catalog provider.', // Výrobce není evidován jako poskytovatel katalogů.
	'recordingProtocolMessage#verr_disr': 'Duplicate ISRC', // Duplicitní ISRC
	'copyMoviesFromPreviousYear': 'Load films from last year\'s declaration', // Načíst filmy z loňského ČP
	'recordingModificationsAwaitProcessing': 'Modifications are being processed', // Provedené změny čekají na zpracování
	'recordingProtocol.invalidACRoleCombination': 'Lineup cannot contain the "A" and "C" roles without also containing the "B" role.', // Role A a C nemohou být společně na lineupu bez toho, aby na něm byla i role B.
	'licences': 'Licences', // Licence
	'removeRecordingFromCatalog': 'Remove recording from catalog', // Odstranit nahrávku z katalogu
	'reallyRemoveRecordingFromCatalog': 'Really remove recording from catalog?', // Opravdu chcete odstranit nahrávku z katalogu?
	'catalogPerformance.1': '1 - singer', // 1 - zpěvák
	'catalogPerformance.2': '2 - soloist on musical instrument', // 2 - hudebník
	'catalogPerformance.3': '3 - musician (member of group)', // 3 - muzikant
	'catalogPerformance.4': '4 - conductor', // 4 - dirigent
	'catalogPerformance.5': '5 - dancer', // 5 - tanečník
	'catalogPerformance.6': '6 - actor', // 6 - herec
	'catalogPerformance.7': '7 - group', // 7 - skupina
	'catalogPerformance.8': '8 - orchestra', // 8 - orchestr
	'catalogPerformance.9': '9 - choir', // 9 - sbor
	'catalogPerformance.12': '12 - chamber orchestra', // 12 - komorní orchestr
	'genre.POP': 'Pop', // Populární hudba
	'genre.CLS': 'Classical', // Klasická hudba
	'genre.SPK': 'Spoken word', // Mluvené slovo
	'noMatchingCinemaAttendancesFound': 'No matching records found', // Nenalezeny žádné odpovídající záznamy.
	'recordingProtocolMessage#verrDisr': 'Duplicate ISRC', // Duplicitní ISRC

	'permanentCatalogDetail': 'Recording detail', // Detail nahrávky
	'invalidPinDob': 'Invalid PIN/DOB format', // Neplatný formát RČ/dat.nar.
	'invalidISRC': 'Invalid ISRC format', // Neplatný formát ISRC
	'approve': 'Approve', // Schválit
	'reallyApproveRecordingProtocol': 'Really approve the recording protocol?', // Opravdu schválit nahrávací protokol?
	'recordingProtocolAdminStatusComments.deny': 'Reasons for rejection', // Zdůvodnění zamítnutí
	'recordingProtocolAdminStatusComments.return': 'Reasons for return', // Zdůvodnění vrácení
	'return': 'Return', // Vrátit
	'deny': 'Reject', // Zamítnout
	'RecordingProtocolAdmin': 'Recording Protocol Administration', // Správa nahrávacích protokolů
	'recordingProtocol.aloPerormer': 'Enter at least one performer involved in the recording.', // Zadejte alespoň jednoho umělce podílejícího se na nahrávce.
	'shareOrRoleOrNothing.S': 'Share', // Podíl
	'shareOrRoleOrNothing.R': 'Role', // Role
	'shareOrRoleOrNothing.N': 'Neither', // Ani jedno
	'recordingProtocolCLSMissingComposer': 'If the author of the music is not filled in, foreign payments cannot be claimed.', // Pokud nebude autor hudby vyplněn, nelze nárokovat odměny ze zahraničí.
	'recordingProtocolCopyButtonHeader.album': 'Register another recording on the album.', // Registrovat další nahrávku na albu
	'recordingProtocolCopyButtonText.album': 'A copy of this recording will be created with a blank ISRC, title and runtime. ', // Bude vytvořena kopie této nahrávky s prázdným ISRC, titulem a stopáží.
	'recordingProtocolCopyButtonHeader.empty': 'Register another recording', // Registrovat další nahrávku
	'recordingProtocolCopyButtonText.empty': 'A blank recording will be created.', // Bude vytvořena prázdná nahrávka.
	'recordingProtocolCopyButtonHeader.video': 'Register a video version of the recording', // Registrovat video verzi nahrávky
	'recordingProtocolCopyButtonText.video': 'A copy of this recording will be created with the type set to "Video Clip"', // Bude vytvořena kopie této nahrávky s typem nastaveným na "Videoklip"
	'recordingProtocolCopyButtonHeader.exact': 'Create a copy of the recording', // Vytvořit kopii nahrávky
	'recordingProtocolCopyButtonText.exact': ' A copy of this recording will be created with all data retained.', // Bude vytvořena kopie této nahrávky se zachováním všech údajů.
	'reallyProceedToLineupNoIsrc': 'Are you sure you want to continue? If the ISRC is not filled in, the recording will be registered with a lower relevance than the ISRC Protocol.', // Opravdu chcete pokračovat? Pokud nebude vyplněn ISRC, bude nahrávka zaregistrována s nižší relevancí než nahrávací protokol.
	'reallyCloseModifiedRecordingProtocolDetail': 'Are you sure you want to close the tab?\n\nThe changes you have made will be discarded.', // Opravdu chcete zavřít záložku?\n\nProvedené změny budou zahozeny.
	'reallyCloseModifiedPermanentCatalogRecordingDetail': 'Are you sure you want to close the tab?\n\nThe changes made will be discarded.', // Opravdu chcete zavřít záložku?\n\nProvedené změny budou zahozeny.
	'submitRecordingProtocol': 'Register the recording', // Registrovat nahrávku
	'recordingProtocolDeclaration.PRO': 'I certify the accuracy and completeness of the performances listed as the producer of the recording.', // Potvrzuji správnost a úplnost uvedených výkonů z pozice výrobce náhrávky.
	'recordingProtocolDeclaration.ADM': 'As the producer of the recording, I confirm the accuracy and completeness of the listed performances.', // Potvrzuji správnost a úplnost uvedených výkonů z pozice společného zástupce souboru.
	'recordingProtocolDeclaration.PER': 'As a performing artist participating in the recording, I confirm the accuracy of the information provided.', // Potvrzuji správnost uvedených údajů z pozice výkonného umělce participujícího na nahrávce.
	'recordingProtocolDeclaration.PER.hint': 'I acknowledge that the recording will be registered with lower relevance and with the possibility of later editing by other rights holders or users.', // Beru na vědomí, že nahrávka bude registrována s nižší relevancí a s možností pozdější editace dalšími nositeli práv či uživateli.
	'creatorRole.PER.POP.A': 'A - Soloist', // A - Sólista
	'creatorRole.PER.POP.B': 'B - Main performance', // B - Hlavní výkon
	'creatorRole.PER.POP.C': 'C - Additional performance', // C - Vedlejší výkon
	'creatorRole.PER.CLS.D': 'D - Soloist', // D - Sólista
	'creatorRole.PER.CLS.E': 'E - Conductor', // E - Dirigent
	'creatorRole.PER.CLS.F': 'F - Chorus-master', // F - Sbormistr
	'creatorRole.PER.CLS.G': 'G - Orchestra member', // G - Člen orchestru
	'creatorRole.PER.CLS.H': 'H - Chorus member', // H - Člen sboru
	'creatorRole.PER.CLS.I': 'I - Chamber ensemble member', // I - Člen komorního souboru
	'creatorRole.PER.POP.X': 'X - Unknown performance', // X - Neznámý výkon
	'creatorRole.PER.CLS.Y': 'Y - Unknown performance', // Y - Neznámý výkon
	'totalShareMustBe100': 'The total share must be 100%', // Celkový podíl musí být 100%
	'recordingProtocol.composers': 'Music composers', // Autoři hudby
	'recordingProtocol.lyricists': 'Lyricists', // Autoři textu
	'recordingProtocol.performers': 'Recording performers', // Umělci podílející se na nahrávce
	'recordingProtocol.authors': 'Authors', // Autoři
	'recordingProtocolAuthorRole.AH': 'Composer', // Autor hudby
	'recordingProtocolAuthorRole.AT': 'Lyricist', // Autor textu
	'correctTheFollowingErrors': 'Please correct the following errors', // Opravte prosím následující chyby
	'recordingProtocolGenre.POP': 'Popular music', // Populární hudba
	'recordingProtocolGenre.CLS': 'Classical music', // Klasická hudba
	'releaseOrProductionYearIsMandatory': 'Year of creation or first release is mandatory', // Rok vzniku nebo prvního vydání je povinný
	'recordingProtocolRecordingType.A': 'A - Audio', // A - Audio
	'recordingProtocolRecordingType.V': 'V - Video clip', // V - Videoklip
	'recordingRegistration': 'Registration of a new recording', // Registrace nové nahrávky
	'cancelRecordingProtocolEntry': 'Cancel recording protocol entry', // Zrušit zadávání nahr. protokolu
	'cancelRecordingRegistration': 'Cancel recording registration', // Ukončit registraci nahrávky
	'reallyCancelRecordingRegistration': 'Really cancel recording registration?', // Opravdu ukončit registraci nahrávky?
	'createIsrcRecordingProtocol': 'Complete the recording protocol', // Vyplnit nahrávací protokol
	'createCatalogRecordingProtocol': 'Add a recording to the producer’s catalog', // Přidat nahrávku do katalogu výrobce
	'createIsrcAndCatalogRecordingProtocol': 'Add a recording to the producer’s catalog and also complete the recording protocol.', // Přidat nahrávku do katalogu výrobce a současně vyplnit nahrávací protokol
	'createIsrcRecordingProtocolHint': 'I am registering only the performing artists’ performances, not the producer’s rights.', // registruji pouze výkony výkonných umělců, nikoliv práva výrobce
	'createCatalogRecordingProtocolHint': 'I am registering only the producer’s rights.', // registruji pouze práva výrobce
	'createIsrcAndCatalogRecordingProtocolHint': 'I am registering both the producer’s rights and the performances of performing artists.', // registruji práva výrobce i výkony výkonných umělců
	'recordingProtocolTypeSelection': 'Select a protocol type', // Výběr typu protokolu
	'registerNewRecording': 'Register a new recording', // Zaregistrovat novou nahrávku
	'recordingProtocols': 'Submitted recording registrations', // Podané registrace nahrávek
	'registeredRecordings': 'Registered recordings', // Evidované nahrávky
	'backToBasicInfo': 'Back to basic data', // Zpět na základní údaje
	'recordingProtocolCount': 'Number of recording protocols', // Počet nahrávacích protokolů
	'proceedToRecordingProtocolSummary': 'Proceed to recording protocol summary', // Pokračovat na souhrn zadaných údajů
	'recordingProtocolSummary': 'Overview of data entered', // Přehled zadaných údajů
	'backToLineup': 'Back to the lineup', // Zpět na lineup
	'proceedToLineupEntry': 'Proceed to lineup entry', // Pokračovat na zadání lineupu
	'noUserHistoryMessage': 'No changes detected for the user.', // Neevidujeme u uživatele žádné změny.
	'userPartyAdded': 'Add a party', // Přidání osoby
	'userPartyDeleted': 'Party removal', // Odstranění osoby
	'userModification': 'Change user data', // Změna údajů uživatele
	'currencies': 'Currencies', // Měny
	'CatalogRecording': 'Recording catalog', // Katalog nahrávek
	'reload': 'Refresh', // Aktualizovat
	'AffirmationDistributionResult': 'Statutory declaration (AV) results', // Výsledky vyúčtování ČP
	'cannotExportThereAreMissingExchangeRates': 'Export cannot be done, exchange rates are not defined for the following currencies: $currencies', // Export nelze provést, pro následující měny nejsou nadefinovány směnné kurzy: $currencies
	'cannotExportThereAreMissingExchangeRate': 'Export cannot be done, exchange rate is not defined for the following currency: $currencies', // Export nelze provést, pro následující měnu není nadefinován směnný kurz: $currencies
	'producerSummary': 'Producers overview', // Přehled výrobců
	'missingExchangeRates': 'Missing exchange rates', // Chybějící kurzy
	'affirmationSubmissionItemType.C': 'Cinema attendance', // Návštěvnost kin
	'affirmationSubmissionItemType.B': 'Broadcast', // Vysílání
	'affirmationSubmissionItemType.S': 'Sales', // Prodej
	'exportAllCompletedSubmissionsToExcel': 'Export all completed submissions to Excel', // Exportovat všechna dokončená podání do Excelu
	'reallySetStatusTo': 'Really set the status to "$status"?', // Opravdu nastavit status na "$status"?
	'setStatusTo': 'Set the status to "$status"',
	'conflictResolution': 'Conflict resolution', // Řešení konfliktů
	'passToProducers': 'Pass to producers', // Předat výrobcům
	'refreshConflictsForDistributionPeriod': 'Refresh conflicts for period $distributionPeriodId', // Aktualizovat konflikty pro období $distributionPeriodId
	'passedToProducers': 'Passed to producers', // Předáno výrobcům
	'ignored': 'Ignored', // Ignorováno
	'conflictResolutionWillBeOpen': 'Conflict corrections will be enabled from *$fromDate*', // Opravy konfliktů bude možné provádět od *$fromDate*.
	'conflictResolutionIsClosed': 'Conflict repair is not enabled at this time.', // Opravy konfliktů v tuto chvíli není možné provádět.
	'ignore': 'Ignore', // Ignorovat
	'waitingForYourDecision': 'Waiting for your evaluation', // Čeká na vaše vyhodnocení
	'resolved': 'Resolved', // Vyřešeno
	'submissionList': 'Submissions', // Podání
	'attendanceMismatch': 'Attendance mismatch', // Neshoda v návštěvnosti
	'runtimeMismatch': 'Runtime mismatch', // Neshoda ve stopáži
	'productionYearMismatch': 'Year of production mismatch', // Neshoda v roku výroby
	'sameDigitalSaleIncome': 'Matching digital sales', // Shodný digitální prodej
	'samePhysicalSaleIncome': 'Matching physical sales', // Shodný fyzický prodej
	'anomalies': 'Anomalies', // Anomálie
	'conflicts': 'Conflicts', // Konflikty
	'exportToExcel': 'Export to the Excel', // Vyexportovat do Excelu
	'importFromExcel': 'Import from Excel', // Naimportovat z Excelu
	'affirmationImport.existingDataWillBeReplaced': 'Do you really want to do the import?\n\nThe existing data will be deleted and replaced with the data from the imported file.', // Opravdu chcete provést import?\n\nStávající data budou smazána a nahrazena daty z importovaného souboru.
	'correctionReasonIsMandatoryLong': 'Provide justification for the correction to \'$title\'.', // Doplňte zdůvodnění opravy/doplnění pro "$title"
	'correctionReasonIsMandatory': 'Provide a justification for the correction/addition by clicking on the "Correction" button on the right.', // Doplňte zdůvodnění opravy/doplnění kliknutím na tlačítko "Oprava" vpravo.
	'reopen': 'Reopen', // Znovu otevřít
	'reallyLeaveModifiedAffirmationSubmission': 'Are you sure you want to close unsaved submissions?\n\nThe changes made will be discarded.', // Opravdu chcete zavřít neuložené podání?\n\nProvedené změny budou zahozeny.
	'productionYearMustNotBeAfterReleaseYear': 'Invalid year of production', // Neplatný rok výroby
	'AffirmationSubmissionAdmin': 'Administration of submissions to the ', // Správa podání ČP VZOZ
	'conflictResolutionToDateMustBeGreaterThanConflictResolutionFromDate': 'The conflict resolution date to must be greater than the conflict resolution date from', // Datum řešení konfliktů do musí být větší než datum řešení konfliktů od
	'cellError.invalidSharePct': 'Invalid share', // Neplatný podíl
	'cellError.invalidProductionYear': 'Invalid year of production', // Neplatný rok výroby
	'cellError.invalidAffirmationRecordingType': 'Invalid type', // Neplatný typ
	'cellError.invalidRuntime': 'Invalid runtime', // Neplatná stopáž
	'cellError.invalidChannel': 'Invalid channel', // Neplatný kanál
	'cellError.invalidAttendance': 'Invalid attendance', // Neplatná návštěvnost
	'cellError.invalidAmount': 'Invalid amount', // Neplatná částka
	'cellError.invalidCurrency': 'Invalid currency', // Neplatná měna
	'uploadingFile': 'Uploading the file $fileName..', // Nahrávám soubor $fileName..


	bc_run_type_id: 'Distribution type',
	bc_run_type: 'Distribution type',
	'submissionResolution.Y': 'Resolved',
	'submissionResolution.N': 'Unresolved',

	'duplicateEntry': 'Duplicate entry', // Duplicitní záznam
	'comment': 'Note', // Poznámka
	'duplicateCinemaAttendanceEntries': 'Cinema attendance contains duplicate entries: $duplicates', // Návštěvnost kin obsahuje duplicitní záznam: $duplicates
	'dragFileOrFiles': 'Drag file(s)', // Přetáhnout soubor(y)
	'updatingBroadcastsFromCinemaAttendance': 'Updating broadcasts from cinema attendance..', // Aktualizuji vysílání z údajů o návštěvnosti..
	'updateBroadcastsFromCinemaAttendance': 'Load films from the "Cinema attendance" tab', // Aktualizovat vysílání z údajů o návštěvnosti
	'updateSalesFromCinemaAttendanceAndBroadcasts': 'Load records from the "Cinema attendance" and "Broadcasting" tabs', // Aktualizovat prodeje z údajů o návštěvnosti a vysílání
	'correctionAddition': 'Correction / Addition', // Oprava/doplnění
	'clearFilter': 'Clear filter', // Vyčistit filtr
	'noMatchingProgrammesFound': 'No matching programmes found.', // Nebyly nalezeny žádné odpovídající pořady.
	'countRowsAdded': '$count rows have been added.', // Bylo přidáno $count záznamů.
	'nowRowsAdded': 'No rows have been added.', // Nebyly přidány žádné záznamy.
	'rowsPerPage5to200': 'Rows per page (5-200)', // Počet záznamů na stránku (5-200)
	'noRecordsFound': 'No records found', // Nenalezeny žádné záznamy
	'displayingTotalCountRecords': '$totalCount records displayed', // Zobrazeno $totalCount záznamů
	'displayingDisplayedCountOutOfTotalCountRecords': '$displayedCount out of $totalCount records displayed', // Zobrazeno $displayedCount z $totalCount záznamů
	'deleteRecord': 'Delete record', // Smazat záznam
	'affirmationSubmissionCannotBeCreatedAtThisMoment': 'Creating new affirmation submissions is not allowed at the moment.', // V tuto chvíli nelze vytvářet nová podání ČP
	'createNewSubmission': 'Create new submission', // Vytvořit nové podání
	'AffirmationSubmission': 'Statutory declaration (AV) submission', // Podání ČP
	'newAffirmationSubmission': 'New statutory declaration submission', // Nové podání ČP
	'attendanceMustNotBeNegative': 'Attendance must not be negative', // Návštěvnost nesmí být záporná
	'runtimeMustNotBeNegative': 'Runtime must not be negative', // Stopáž nesmí být záporná
	'submissionToDateMustBeGreaterThanSubmissionFromDate': 'Submission to must be greater than submission from', // Datum podání do musí být větší než datum podání od
	'cellError.missing': 'Mandatory field', // Povinné pole
	'cellError.invalidDate': 'Invalid date', // Neplatný datum
	'cellError.invalidTime': 'Invalid time', // Neplatný čas
	'importErrorHeader': 'Import "$fileName" contains errors. Correct them and reupload the file.', // Import "$fileName" obsahuje chyby. Opravte je a nahrajte soubor znovu.
	'cellError.invalidNumber': 'Invalid number', // Neplatné číslo
	'importingFile': 'Importing $fileName..', // Importuji soubor $fileName..
	'consolidatingFile': 'Consolidating $fileName..', // Zpracovávám soubor $fileName..
	'onlyIntergramAndRaventiaUsersCanBeAdmins': 'Only Intergram and Raventia users can be admins', // Pouze uživatelé z Intergramu a Raventie mohou být administrátory
	'uploadUfd': 'Upload UFD', // Nahrát UFD
	'uploadPressdata': 'Upload Pressdata', // Nahrát Pressdata
	'basicInfo': 'Basic information', // Základní údaje
	'importSuccessful': '$fileName has been successfuly imported.', // Soubor $fileName byl úspěšně naimportován.
	'selectOneFile': 'Select one file', // Vyberte jeden soubor
	'loginAsUser': 'Login as user', // Přihlásit se jako uživatel
	'aboutPortal': 'About portal', // O klientském portále
	'AffirmationSubmissionSettings': 'Affirmation submission settings', // Správa podání ČP
	'BankId': 'Bank identities', // Bankovní identity
	'pwd.passwordVerification': 'password and its verification do not match', // heslo a jeho ověření se shodují
	'shareMustBeBetween0And100': 'Share must be between 0 and 100', // Podíl musí být mezi 0 a 100
	'productionYearMustBeBetweenMinAndMax': 'Production year must be between $min and $max.', // Rok výroby musí být mezi $min a $max.
	publicationYearMustBeBetweenMinAndMax: 'Year of publication must be between $min and $max.',
	'productionPublicationYearMustBeBetweenMinAndMax': 'Production/publication year must be between $min and $max.', // Rok výroby/zveřejnění musí být mezi $min a $max.

	'cellError.invalidProductionYear.affSub.2016': 'Year of publicartion must be between 1965 and 2016.',
	'cellError.invalidProductionYear.affSub.2017': 'Year of publicartion must be between 1966 and 2017.',
	'cellError.invalidProductionYear.affSub.2018': 'Year of publicartion must be between 1967 and 2018.',
	'cellError.invalidProductionYear.affSub.2019': 'Year of publicartion must be between 1968 and 2019.',
	'cellError.invalidProductionYear.affSub.2020': 'Year of publicartion must be between 1969 and 2020.',
	'cellError.invalidProductionYear.affSub.2021': 'Year of publicartion must be between 1970 and 2021.',
	'cellError.invalidProductionYear.affSub.2022': 'Year of publicartion must be between 1971 and 2022.',
	'cellError.invalidProductionYear.affSub.2023': 'Year of publicartion must be between 1972 and 2023.',
	'cellError.invalidProductionYear.affSub.2024': 'Year of publicartion must be between 1973 and 2024.',
	'cellError.invalidProductionYear.affSub.2025': 'Year of publicartion must be between 1974 and 2025.',
	'cellError.invalidProductionYear.affSub.2026': 'Year of publicartion must be between 1975 and 2026.',
	'cellError.invalidProductionYear.affSub.2027': 'Year of publicartion must be between 1976 and 2027.',
	'cellError.invalidProductionYear.affSub.2028': 'Year of publicartion must be between 1977 and 2028.',
	'cellError.invalidProductionYear.affSub.2029': 'Year of publicartion must be between 1978 and 2029.',
	'cellError.invalidProductionYear.affSub.2030': 'Year of publicartion must be between 1979 and 2030.',
	'cellError.invalidProductionYear.affSub.2031': 'Year of publicartion must be between 1980 and 2031.',
	'cellError.invalidProductionYear.affSub.2032': 'Year of publicartion must be between 1981 and 2032.',
	'cellError.invalidProductionYear.affSub.2033': 'Year of publicartion must be between 1982 and 2033.',
	'cellError.invalidProductionYear.affSub.2034': 'Year of publicartion must be between 1983 and 2034.',

	userExpired: 'Your portal user account has been terminated. Contact us at portal@intergram.cz',
	setBankIdentityUserConfirmation: 'Do you really want to link the bank identity to user account $userName?\n\nNotification email will be sent to $emails.',
	and: 'and',
	userNameMustNotContainSpaces: 'User name must not contain spaces',
	'submissionRole.PER': 'Performers',
	'submissionRole.PRO': 'Producers',
	matchUser: 'Match user',
	userNameMatch: 'User name match',
	candidates: 'Candidates',
	createUser: 'Create user',
	createAndMatch: 'Create and match',
	newUser: 'New user',
	profileIsLinkedToBankIdentity: 'The user profile is linked to a bank identity.',
	profileWasLinkedToBankIdentity: 'The user profile was (but no longer is) linked to a bank identity.',
	'unmatchedBankIdLoginMessage.line1': 'Your bank identity has not been linked to a portal account.',
	'unmatchedBankIdLoginMessage.line2': 'If you have a username/password, use them to log in and your portal account will be linked to the bank identity. Next time you will be able to log in using just Bank iD.',
	'unmatchedBankIdLoginMessage.line3': 'If you do not have access to the portal yet, wait for Intergram to manualy verify your request and contact you.',
	'unmatchedBankIdLoginMessage.userExpired': 'The user account linked to this identity is locked. Contact Intergram.',
	'unmatchedBankIdLoginMessage.generalError': 'An error occurred during the login process.',

	includingDeleted: 'Including deleted',
	termsOfService: 'Terms of service',

	loginWithUserNameAndPassword: 'Login with user name and password',
	loginWithBankId: 'Log in with Bank iD',
	bankIdLoginBlockText: 'Now you can log in with Bank iD. Click the link, select your bank and log in like you would into your online banking.',//'Nově můžete použít Bank iD, po kliknutí na odkaz stačí vybrat svou banku a přihlásit se stejně jako do svého internetového bankovnictví.',
	reallyDeleteBankIdentity: 'Are you sure you want to delete this bank identity?',
	unmatched: 'Unmatched',
	matched: 'Matched',
	deleted: 'Deleted',
	bankIdentities: 'Bank identities',
	removeBankIdentity: 'Remove bank identity',
	reallyRemoveBankIdentity: 'Are you sure you want to remove this bank identity?\n\nYou won\'t be able to use it to log into the portal any more.',
	noBankIdentityConnectedToThisUserAccount: 'Your user account is not linked to any bank identity.\n\nIf you want to use bank identity to log into your portal account, click "Login with Bank iD" next time you log into the portal.',


	'Dashboard': 'Dashboard',
	invalidPassword: 'Invalid password',
	profile: 'Profile',
	IP: 'II',
	NP: 'UI',
	'UsageReport': 'Usage and remuneration',
	'MyRecordings': 'My recordings',
	Label: 'Labels',
	'Submissions': 'Submissions',
	'Notifications': 'Notifications',
	'SystemSettings': 'System settings',
	'SessionLog': 'Session log',
	'NotificationAdmin': 'Notification administration',
	'UserProfile': 'User profile',
	'SystemMaintenance': 'System outage',
	'dashboard.subHeader.broadcaster': 'Broadcaster',
	'dashboard.subHeader.channel': 'Channel',
	'dashboard.subHeader.audioVideo': 'Audio / Video',
	'backToOverview': 'Back to Dashboard',
	'cancelChanges': 'Cancel changes',
	'maintenanceNotification': 'On *$day* there is planned outage in time *$timeFrom* - *$timeTo* due to maintenance. Your work will be saved prior to start of outage.',
	'performerSignIn': 'Performer web',
	'producerSignIn': 'Producer web',
	'youNeedToSignIn': 'You need to sign in or register in order to log into portal.',
	'stayLoggedIn': 'Stay logged',
	'sessionLogoutInLessThan': 'You will be logged off in less than',
	'minutes.1': 'minute',
	'minutes.2': 'minutes',
	'minutes.3': 'minutes',
	'minutes.4': 'minutes',
	'minutes.x': 'minutes',
	'youHaveBeenLoggedOut': 'Your were logged off',
	'dashboardNoDataMessage': 'No remuneration available.',
	'myRecordingsNoDataMessage': 'There are no recordings available.',
	'rowCount': 'Number of records',
	'next': 'Next',
	'previous': 'Previous',
	'processingRequest': 'Request is being processed',
	'czk': 'CZK',
	'delete': 'Delete',
	'help': 'Help',
	'showAltNames': 'display alternative names',
	'altNames': 'Alternative names',
	'hide': 'hide',
	'logout': 'Log out',
	'noItemsFound': 'No items found',
	'save': 'Save',
	'ok': 'OK',
	'personalInfo': 'Personal info',
	'roleList': 'Role list',
	'cancel': 'Cancel',
	'displayedRecordings': 'Displayed recordings',
	'recordingCount': 'Recording count',
	'pageNumber': 'Go to page',
	'rowsPerPage': 'Records on page',
	'exportSelectionToCSV': 'Export selection to CSV',
	'childRoleRelType.MEM': 'Ensamble memeber',
	'childRoleRelType.ADM': 'Joint representative',
	'footer.socialNetworks': 'Keep in touch on social media',
	'recordingTypeA': 'Audio',
	'recordingTypeV': 'Video',
	'distType.IP': 'II (Identifiable)',
	'distType.NP': 'UI (Unidentifiable)',
	'audioVideo.A': 'Audio',
	'audioVideo.V': 'Video',
	'recordingSource.isrcProtocol': 'From ISRC protocol',
	'recordingSource.other': 'From different sources',
	'readingItems': 'Loading items',
	'mandatoryField': 'Mandatory field',
	'maintenanceToMustBeGreaterThanMaintenanceFrom': 'End of outage time must be later than start of outage ',
	'notificationFromDateMustBeLessThanMaintenanceFrom': 'Notification from must be prior start of outage',
	'maintenanceFromAndToMustBeSameDay': 'Begining and end of outage must be in same day',
	'toDateMustBeGreaterThanFromDate': 'End of notification must be later than its start',
	'new.systemMaintenance': 'New system outage',
	'new.notification': 'New notification',
	'ynBoolean.Y': 'Yes',
	'ynBoolean.N': 'No',
	'validationMessageHeader': 'Please fix errors:',
	'validationIgnorableErrors': 'Form contains errors, that do not prevent saving:',
	'validationIgnorableErrors2': 'Form contains also errors, that do not prevent saving:',
	'validationWarnings': 'Warning',
	'saveAnyway': 'Save anyway',
	'backToForm': 'Back to form',
	'isAMandatoryField': ' is a mandatory field',

	'refresh': 'Refresh',
	'rightHolderReward': 'Remuneration',
	'submissionTransition.NEW2SAVED_FOR_LATER': 'Created and saved for later',
	'submissionTransition.NEW2SUBMITTED': 'Created and submitted',
	'submissionTransition.SUBMITTED': 'Submitted',
	'submissionTransition.SUBMITTED2IN_PROGRESS': 'Your submission is being processed',
	'submissionStatusChange': 'Submission status change',
	'changeHistory': 'History of changes',
	'SubmissionAdmin': 'Submission administration',
	'more': 'More',
	'fileSubmission': 'Send your submission',
	'setSubmissionStateTo': 'Set status to',
	'attachANoteOrAFile': 'Add a note or an attachment',
	'uploadingFileProgress': 'Loading file $fileName..$progress%',
	'selectAttachment': 'Select an attachment',
	'fileSizeSumLimitExceeded': 'File(s) cannot be uploaded, maximum attachment size would be exceeded ($limit)',
	singleFileSizeLimitExceeded: 'File ($fileName) cannot be uploaded, it exceeds size limit ($limit)',
	'or': 'or',
	'attachmentDragText': 'Drag your files here',
	'maxSize': 'max. size',
	'list': 'List',
	'saveForLater': 'Save for later',
	'UserAdmin': 'User administration',
	'AuthenticationCode': 'Authorization codes',
	'Submission': 'Submission',
	'newSubmission': 'New submission',
	'troubleChangingPasswordOrSigningIn': 'Any troubles with password change or login?',
	'sendErrorMessage': 'Sending error',
	'authenticationErrorCode.-20056': 'User entered an invalid code',
	'authenticationErrorCode.-20057': 'The code has expired',
	'forgottenPassword': 'Forgotten password?',
	'passwordChange': 'Password change',
	'passwordReset': 'Creating a new password',
	'passwordHasBeenChanged': 'Your password has been changed',
	'passwordResetEmailSent': 'Link for password change has been sent to *$email* email.',
	'userActivated': 'User activated on $when',
	'userActivationSent': 'Activation email sent on $when',
	'passwordsDoNotMatch': 'Passwords do not match',
	'createYourPortalPassword': 'Create a new password to login to the portal',
	'passwordMustMeetTheseCriteria': 'The password must have',
	'pwd.min8Chars': 'minimum of 8 characters',
	'pwd.upperLower': 'one lower case and one upper case letter',
	'pwd.specialChars': 'minimum of 1 number or a special character',
	'pwd.newPasswordVerification': 'new password and its verification are the same',
	'submit': 'Send',
	'nowYouCanLogIn': 'Now you may login.',
	'activationSuccessful': 'Portal access activation completed.',
	'passwordCreation': 'Password creation',
	'back': 'Back',
	'invalidSmsCode': 'Invalid SMS code entered',
	'invalidUserName': 'Invalid username',
	'smsCodeExpired': 'SMS code expired',
	'invalidActivationCode': 'Invalid activation code',
	'activationCodeExpired': 'Activation code expired',
	'smsNotReceived': 'No SMS received?',
	'enterSmsCode': 'Please enter the SMS login code we have sent to your *mobile phone* ($phone). ',
	'passwordResetHint': 'Please enter your username. Link for password change will be sent to your *email* ',
	'invalidCredentials': 'Invalid credentials',
	'smsAuthentication': 'SMS verification',
	'errorSendingLoginCodeSms': 'Error when sending the SMS with login code',
	'welcomeHeader': 'Welcome to the client portal',
	'contractNeededForAccess': 'To enter the client portal you need to sign a contract with Intergram first.',
	'iHaveAContract': 'I already have a contract',
	'iDontHaveAContract': 'I do not have a contract',
	'needAdvice': 'Do you need an advice?',
	troubleSigningIn: 'Trouble logging in?',
	'loginNoun': 'Login',
	'login': 'Login',
	'iAmARegisteredUser': 'I have login credentials for the client portal.',
	'newContract': 'Starting a contract with Intergram',
	'iWantAContract': 'I have no contract but I want to use the Intergram client portal.',
	'sendActivationLink': 'Send the activation link',
	'yes': 'Yes',
	'no': 'No',
	'activationLinkSent': 'Activation link sent successfully',
	'reallySendActivationLink': 'Confirm sending the activation link',
	'duplicateUserName': 'Such username already exists.',
	'terminate': 'Terminate',
	'reactivate': 'Reactivate',
	'new.user': 'New user',
	'usageReportFlag_P.short': 'S',
	'usageReportFlag_P': 'Sales',
	'usageReportFlag_R.short': 'R',
	'usageReportFlag_R': 'Rerun',
	'inDetail': 'Detailed statement',
	'aggregatedItems': 'Aggregated statement',
	'usageReport.time_used_sum.subText': 'hh:mm:ss',
	'usageReport.spins_sum.subText': 'uses',
	'usageReport.ip_gross_amount_sum.subText': 'CZK (gross)',
	'usageReport.np_gross_amount_sum.subText': 'CZK (gross)',
	'doYouWantToSaveOpenSubmission': 'Do you want to save your open submission?',
	'saveAndClose': 'Save and close',
	'doCancelSubmission': 'Yes, cancel my submission',
	'reallyCancelSubmission': 'Confirm cancelling your submission',
	'cancelSubmission': 'Cancel my submission',
	'close': 'Close',
	'closeWithoutSaving': 'Close without saving',
	'youHaveMadeSubmissionChanges': 'You made changes to your open submission, do you want to save them before closing?',
	'anotherModifiedSubmission': 'You have another open submission, do you want to save it and open a new one?',
	'usageReportNoDataMessage': 'You have no usage',
	'saveAndOpenNew': 'Save and open a new one',
	'openWithoutSaving': 'Open a new one without saving',
	'submissionStatusGroup.OPEN': 'Open submissions',
	'submissionStatusGroup.SUBMITTED': 'Sent submissions',
	'submissionStatusGroup.CLOSED': 'Closed submissions',
	'displayedSubmissions': 'Displayed submissions',
	'submissionCount': 'Number of submissions',
	'submissionTransition.NEW2SAVEDFORLATER': 'Created and saved for later completion',
	'submissionTransition.SUBMITTED2INPROGRESS': 'Your submission was accepted and is being processed',
	'usageReportFlagP.short': 'S',
	'usageReportFlagP': 'Sales',
	'usageReportFlagR.short': 'R',
	'usageReportFlagR': 'Rerun',
	'usageReport.timeUsedSum.subText': 'usage times',
	'usageReport.spinsSum.subText': 'usage',
	'usageReport.ipGrossAmountSum.subText': 'CZK (gross)',
	'usageReport.npGrossAmountSum.subText': 'CZK (gross)',
};

const columnTexts = {
	bc_run_type_id: 'Distribution type',
	bc_run_type: 'Distribution type',
	'notification_channel': 'Channel',
	'text': 'Text',
	'maintenanceFrom': 'Start',
	'maintenanceTo': 'End',
	'systemMaintenance.fromDate': 'Start',
	'systemMaintenance.toDate': 'End',
	'from_date': 'From',
	'to_date': 'To',
	'logoutWarningThreshold': 'Logout notification period (minutes)',
	'sessionDurationInMinutes': 'Session duration (minutes)',
	'account_category': 'Rights category',
	'usage_year': 'Year of usage',
	'income_type': 'Income type',
	'reward_amount': 'remuneration amount',
	'reward_netto': 'To be paid',
	'categoryName.dashboard': 'Rights category',
	'effectivePeriodId.dashboard': 'Year of usage',
	'distType.dashboard': 'Income type',
	brutto: 'Gross',
	netto: 'Net',
	'brutto.dashboard': 'Remun. amount',
	'netto.dashboard': 'To be paid',
	'total_netto_reward': 'Total amount to be paid',
	'highest_reward_category': 'Highest remuneration in category',
	'top_channel': 'Most often on channel',
	'most_profitable_recording': 'Most profitable recording',
	'person_group': 'Person | Group',
	'role': 'Role',
	'distribution_period': 'Distribution period',
	'session_id': 'ID',
	'user': 'User',
	'proxy_user': 'Proxy user',
	'login_type': 'Login type',
	'login_time': 'Login time',
	'logout_time': 'Logout time',
	'last_access_time': 'Last login',
	'recording': 'Recording',
	'production_release_year': 'Year of production (release)',
	'length': 'Runtime',
	'audio_video': 'Audio/Video',
	'isrc': 'ISRC',
	'from': 'From ',
	'to': 'To',
	'profile_name': 'Profile name',
	'first_name': 'Name',
	'last_name': 'Surname',
	'date_of_birth': 'Date of birth',
	'profile_type': 'Profile type',
	'email': 'E-mail',
	'phone': 'Phone',
	'street_and_house_number': 'Street and house number',
	'city': 'City',
	'zip_code': 'Zip code',
	'day': 'Day',
	'notification_from_date': 'Notification from',
	'comments': 'Comment',
	'is_deleted': 'Deleted',
	'is_active': 'Active',
	'created_when': 'Created',
	'edited_when': 'Edited',
	'maintenance': 'Maintenance',
	'notificationChannel': 'Channel',
	'fromDate': 'From',
	'toDate': 'To',
	'accountCategory': 'Rights category',
	'usageYear': 'Year of usage',
	'incomeType': 'Income type',
	'rewardAmount': 'Remuneration amount',
	'rewardNetto': 'To be paid',
	'totalNettoReward': 'Total amount to be paid',
	'highestRewardCategory': 'Highest remuneration in category',
	'topChannel': 'Most often on channel',
	'mostProfitableRecording': 'Most profitable recording',
	'personGroup': 'Person | Group',
	'distributionPeriod': 'Distribution period',
	'sessionId': 'ID',
	'proxyUser': 'Proxy user',
	'loginType': 'Login type',
	'loginTime': 'Login time',
	'logoutTime': 'Logout time',
	'lastAccessTime': 'Last login',
	'productionReleaseYear': 'Year of production (release)',
	'audioVideo': 'Audio/Video',
	'profileName': 'Profile name',
	'firstName': 'Name',
	'lastName': 'Surname',
	'dateOfBirth': 'Date of birth',
	'profileType': 'Profile type',
	'streetAndHouseNumber': 'Street and house number',
	'zipCode': 'Zip code',
	'notificationFromDate': 'Notification from',
	'isDeleted': 'Deleted',
	'isActive': 'Active',
	'createdWhen': 'Created',
	'editedWhen': 'Edited',

	'production_year.affirmationCinemaAttendance': 'Year of publication',
	'production_year.affirmationBroadcast': 'Year of publication',
	'production_year.affirmationSale': 'Year of publication',
	'production_year.affirmationAttachment': 'Year of publication',

	'nameAndSurname': 'Name and surname',
	'production_year': 'Year of production',
	'release_year': 'Release year',
	'is_isrc_protocol': 'ISRC protocol',
	'station': 'Station',
	'last_modified': 'Last modified',
	'usage_date': 'Usage date',
	'recording_type_id': 'Audio / video',
	'recording_id': 'Recording id',
	'time_used': 'Time used',
	'spins': 'Usage count',
	'ip_gross_amount': 'Identifiable income',
	'np_gross_amount': 'Unidentifiable income',
	'ip_gross_amount.short': 'II amount',
	'np_gross_amount.short': 'UI amount',
	'is_rerun': 'Rerun',
	'is_sale': 'Sale',
	'title': 'Title',
	'subtitle': 'Sub-title',
	'broadcaster': 'Broadcaster',
	'party': 'Person',
	'from_date.authenticationCode': 'Valid from',
	'to_date.authenticationCode': 'Valid to',
	'used_when': 'Used',
	'authentication_code_type': 'Code type',
	'authentication_code_status': 'Status',
	'authentication_code': 'Code',
	'sent_to': 'Sent to',
	'user_name': 'User name',
	'display_name': 'Name',
	'language': 'Language',
	'activated': 'Activated',
	'languageId.form': 'Language',
	'smsCode': 'SMS code',
	'password': 'Password',
	'attachments': 'Attachments',
	'submission_id': 'Submission id',
	'password_verification': 'Password verification',
	newPassword: 'New password',
	oldPassword: 'Current password',
	parties: 'Parties',
	'newPasswordVerification': 'New password verification',
	'name.submission': 'Submission title',
	'type.submission': 'Submission topic',
	'role_id.submission': 'Submission on behalf of',
	'comments.submission': 'Note',
	'party_id.submission': 'Submission on behalf of',
	'party_id.recordingProtocol': 'Submission on behalf of',
	'party_id.affirmationSubmission': 'Submission on behalf of',
	'submitted_when.submission': 'Submitted (created)',
	'status': 'Status',
	'submitted_by': 'Submitted by',
	'productionYear': 'Production year',
	'releaseYear': 'Release year',
	'isIsrcProtocol': 'ISRC protocol',
	'lastModified': 'Last change',
	'usageDate': 'Usage date and time',
	'recordingTypeId': 'Audio / video',
	'recordingId': 'Recording id',
	'timeUsed': 'Used time',
	'ipGrossAmount': 'II amount',
	'npGrossAmount': 'UI amount',
	'isRerun': 'Rerun',
	'isSale': 'Sale',
	'fromDate.authenticationCode': 'Valid from',
	'toDate.authenticationCode': 'Valid to',
	'usedWhen': 'Used',
	'authenticationCodeType': 'Code type',
	'authenticationCodeStatus': 'State',
	'authenticationCode': 'Code',
	'sentTo': 'Sent to',
	'userName': 'User name',
	'displayName': 'Name',
	'submissionId': 'Submission id',
	'passwordVerification': 'Password verification',
	'roleId.submission': 'Submission on behalf of',
	'submittedWhen.submission': 'Submitted (created)',
	'submittedBy': 'Submitted by',
	'born.short': 'b.',

	'producer.tabularCatalog':'Producer',
	'label.tabularCatalog':'Label',
	'title.tabularCatalog':'Recording title',
	'subtitle.tabularCatalog':'Subtitle, version',
	'alt_title.tabularCatalog':'Alternative title',
	'isrc.tabularCatalog':'International Standard Recording Code  (ISRC)',
	'album.tabularCatalog':'Album title or EP',
	'runtime_min.tabularCatalog':'Runtime - minutes',
	'runtime_sec.tabularCatalog':'Runtime - seconds',
	'recording_type_id.tabularCatalog':'Audio recording / Video clip',
	'licence_share_pct.tabularCatalog':'Co-production',
	'main_artist.tabularCatalog':'Main interpret (or group name)',
	'performer1_name.tabularCatalog':'Performer 1',
	'performer1_share_pct.tabularCatalog':'Share - Performer 1',
	'performer1_performance.tabularCatalog':'Performance - Performer 1',
	'performer2_name.tabularCatalog':'Performer 2',
	'performer2_share_pct.tabularCatalog':'Share - Performer 2',
	'performer2_performance.tabularCatalog':'Performance - Performer 2',
	'performer3_name.tabularCatalog':'Performer 3',
	'performer3_share_pct.tabularCatalog':'Share - Performer 3',
	'performer3_performance.tabularCatalog':'Performance - Performer 3',
	'performer4_name.tabularCatalog':'Performer 4',
	'performer4_share_pct.tabularCatalog':'Share - Performer 4',
	'performer4_performance.tabularCatalog':'Performance - Performer 4',
	'performer5_name.tabularCatalog':'Performer 5',
	'performer5_share_pct.tabularCatalog':'Share - Performer 5',
	'performer5_performance.tabularCatalog':'Performance - Performer 5',
	'author_music.tabularCatalog':'Author of music',
	'author_lyrics.tabularCatalog':'Author of lyrics',
	'genre_id.tabularCatalog':'Genre',
	'production_year.tabularCatalog':'Year of production',
	'release_year.tabularCatalog':'Year of first publishing',
	'recording_country_id.tabularCatalog':'Country of production',
	'licence_from_date.tabularCatalog':'Validity of the licence 1',
	'licence_to_date.tabularCatalog':'Validity of the licence 2',
	'ai_generated.tabularCatalog':'Music generated by AI',

	'catalogPerformance.1': '1 - singer',
	'catalogPerformance.2': '2 - soloist on musical instrument',
	'catalogPerformance.3': '3 - musician (member of group)',
	'catalogPerformance.4': '4 - conductor',
	'catalogPerformance.5': '5 - dancer',
	'catalogPerformance.6': '6 - actor',
	'catalogPerformance.7': '7 - group',
	'catalogPerformance.8': '8 - orchestra',
	'catalogPerformance.9': '9 - choir',
	'catalogPerformance.12': '12 - chamber orchestra',


	'production_publication_year': 'Production / publication year', // Rok výroby / zveřejnění
	'submission_from_date': 'Submission from', // Podání od
	'submission_to_date': 'Submission to', //  Podání do
	'new_password': 'New password', // Nové heslo
	'new_password_verification': 'New password verification', // Ověření nového hesla
	'old_password': 'Old password', // Stávající heslo
	'role_id.affirmationSubmission': 'Submission on behalf of', // Podání za osobu
	'roleId.affirmationSubmission': 'Submission on behalf of', // Podání za osobu
	'isan': 'ISAN', // ISAN
	'bank_identity_id': 'Id', // Id
	'matched_user': 'Matched user', // Napojený uživatel
	'name': 'Name', // Jméno
	'birth_date': 'Date of birth', // Datum narození
	'phone_number': 'Phone number', // Telefon
	'birth_number': 'Birth number', // Rodné číslo
	'primary_nationality': 'Nationality', // Národnost
	'deleted_when': 'Deleted', // Smazáno
	'userMatchedWhen': 'User matched', // Uživatel napojen
	'is_system_admin': 'System admin', // Systémový administrátor
	'is_submission_admin': 'Submission admin', // Správce podání
	'ufd': 'UFD', // UFD
	'pressdata': 'Pressdata', // Pressdata
	'submission_date_range': 'Submission from - to', // Podání od - do
	'distribution_period_id': 'Distribution period', // Distribuční období
	'original_title': 'Original title', // Původní titul
	'cinema_attendance_record_count': 'No. of entries - cinema attendance', // Poč. zázn. - návštěvnost
	'broadcast_record_count': 'No. of entries - broadcasts', // Poč. zázn. - vysílání
	'sale_record_count': 'No. of entries - sales', // Poč. zázn. - prodej
	'cinema_attendance': 'Cinema attendance', // Návštěvnost kin
	'broadcast': 'Broadcasting', // Vysílání
	'sale': 'Sales', // Prodej
	'distributor': 'Distributor', // Distributor
	'release_date': 'Premiere', // Premiéra
	'country': 'Country', // Země
	'attendance': 'Attendance', // Návštevnost
	'channel': 'Channel', // Kanál
	'broadcast_time': 'Broadcast time', // Čas vysílání
	'year': 'Year', // Rok
	'runtime': 'Runtime', // Stopáž
	'type': 'Type', // Typ
	'row_id': 'Row number', // Číslo řádku
	'recording_name': 'Title of the work', // Název díla
	'original_recording_name': 'Original Film Title',
	'country_id': 'Country', // Země
	'share_pct': 'Share', // Podíl
	'ufd_attendance': 'Attendance according to UFD', // Návštěvnost dle UFD
	'affirmation_recording_type_id': 'Type of record', // Druh záznamu
	'reason': 'Reason', // Zdůvodnění
	'broadcast_start_time': ' Date and time of broadcast start', // Čas zahájení vysílání
	'physical_sale_income': 'Physical sale income', // Příjem za fyzický prodej nosičů bez DPH
	'digital_sale_income': 'Digital sale income', // Příjem z digitálního prodeje bez DPH
	'currency': 'Currency', // Měna
	imported_from_excel: 'Imported from Excel',

	'from.lower': 'from', // od
	'to.lower': 'to', // do
	'licence': 'Licence', // Licence
	'share_pct.movieProducerDistributionResult': 'Share', // Koprodukční podíl
	'film_id': 'Recording ID', // ID titulu
	'total_sale_income': 'Total sales income', // Celkové prodeje
	'broadcast_effective_runtime': 'Total Effective Broadcast Runtime', // Celková odvysílaná stopáž (přepočtená)
	'gross_amount': 'Gross reward', // Brutto odměna
	'gross_amount.movieProducerDistributionResult': 'Total remuneration (gross)', // Celková odměna (btto)
	'conflict_resolution_from_date': 'Conflict resolution from', // Řešení konfliktů od
	'conflict_resolution_to_date': 'Conflict resolution to', // Řešení konfliktů do
	'detail': 'Detail', // Detail
	'role_id.recordingProtocol': 'Submission on behalf of', // Podání za osobu
	'submission_status': 'Status', // Stav
	'submission_type': 'Type', // Typ
	'cinema_attendance_reward': 'Remuneration by cinema attendance (gross)', // Odměna dle návštěvnosti (btto)
	'broadcast_reward': 'Remuneration by broadcast runtime (gross)', // Odměna dle stopáže (btto)
	'sale_reward': 'Remuneration by sales (gross)', // Odměna dle prodejů (btto)
	'total_share_pct': 'Total remuneration', // Celkový podíl
	'producer': 'Producer', // Výrobce
	'producer_id': 'Producer', // Výrobce
	'main_artist': 'Main artist', // Hlavní umělec
	'correction': 'Correction', // Oprava
	'submission_on_behalf_of': 'Submission on behalf of', // Podání za
	'creator_role_id': 'Role', // Role
	'producer_name': 'Producer name', // Název výrobce
	'total_attendance': 'Total attendance', // Celková návštěvnost
	'total_runtime': 'Total runtime', // Celková stopáž
	'currency_id': 'Currency', // Měna
	'total_physical_sale_income': 'Total income from physical sales', // Celkový příjem z fyzických prodejů
	'total_digital_sale_income': 'Total income from digital sales', // Celkový příjem z digitálních prodejů
	'affirmation_recording_type': 'Type of record', // Druh záznamu
	'affSumTotalRuntime': 'Total broadcast runtime', // Celková stopáž
	'affSumTotalPhysicalSaleIncome': 'Total income from physical media sales (excl. VAT)', // Celkový příjem z fyzických prodejů
	'affSumTotalDigitalSaleIncome': 'Total income from digital sales (incl. streaming) (excl. VAT)', // Celkový příjem z digitálních prodejů
	'affSumTotalAttendance': 'Total cinema attendance', // Celková návštěvnost
	'note': 'Note', // Poznámka
	'currrencyId': 'Currency', // Měna
	'exchangeRate': 'Exchange rate', // Směnný kurz
	'added_by': 'Added by', // Přidal(a)
	'added_when': 'Added when', // Přidáno
	'deleted_by': 'Deleted by', // Smazal(a)
	'language_id': 'Language', // Jazyk
	'pin_dob': 'PIN/DOB', // RČ/dat.nar.
	'producer.recordingProtocol': 'Producer/label', // Výrobce/label
	'main_artist.recordingProtocol': 'Main artist/ensemble', // Hlavní umělec/skupina
	'album.recordingProtocol': 'Album title', // Název alba
	'title.recordingProtocol': 'Recording name', // Název nahrávky
	'subtitle.recordingProtocol': 'Subtitle/version', // Podtitul/verze
	'release_year.recordingProtocol': 'Year of first release/publication', // Rok prvního vydání/zveřejnění
	'production_year.recordingProtocol': 'Year of production', // Rok vzniku
	'length.recordingProtocol': 'Runtime (mm:ss)', // Stopáž (mm:ss)
	'recording_country_id.recordingProtocol': 'Country of production', // Země vzniku
	'countryId.recordingProtocol': 'Country of permanent residence', // Země trv. pobytu
	'genre_id': 'Recording genre', // Druh nahrávky
	'recording_country_id': 'Country of recording origin', // Země vzniku nahrávky
	'recordingTypeId.recordingProtocol': 'Type of recording', // Typ nahrávky
	'performer_total_share': 'Total share (%)', // Celkový podíl (%)
	'share': 'Share (%)', // Podíl (%)
	'isPerformerLineupFinal.recordingProtocol': 'I know the complete lineup and personal details of all artists', // Znám kompletní lineup a osobní údaje všech umělců
	'is_ma': 'Main artist', // Hlavní umělec
	'is_main_artist_member': 'Main artist', // Hlavní umělec
	'pin': 'Personal Identification number', // Rodné číslo
	'producer_codes': 'Producer codes', // Kódy výrobce
	'share_or_role': 'Share / role', // Podíl / role
	'label': 'Label', // Label
	'album': 'Album', // Album
	'productionPublicationYear': 'Year of release / publication', // Rok výroby / zveřejnění
	'sharePct.movieProducerDistributionResult': 'Coproduction share', // Koprodukční podíl
	'filmId': 'Title ID', // ID titulu
	'totalSaleIncome': 'Total sales', // Celkové prodeje
	'broadcastEffectiveRuntime': 'Total effective broadcast runtime', // Celková odvysílaná stopáž (přepočtená)
	'grossAmount': 'Brutto reward', // Brutto odměna
	'grossAmount.movieProducerDistributionResult': 'Total reward (gross)', // Celková odměna (btto)
	'submissionFromDate': 'Submission from', // Podání od
	'submissionToDate': 'Submission to', //  Podání do
	'conflictResolutionFromDate': 'Conflict resolution from', // Řešení konfliktů od
	'conflictResolutionToDate': 'Conflict resolution to', // Řešení konfliktů do
	'roleId.recordingProtocol': 'Submission on behalf of', // Podání za osobu
	'submissionStatus': 'Status', // Stav
	'submissionType': 'Typ', // Typ
	'cinemaAttendanceReward': 'Reward by attendance (gross)', // Odměna dle návštěvnosti (btto)
	'broadcastReward': 'Reward by runtime (gross)', // Odměna dle stopáže (btto)
	'saleReward': 'Reward by sales (gross)', // Odměna dle prodejů (btto)
	'totalSharePct': 'Total reward', // Celkový podíl
	performers: 'Performers',
	'bankIdentityId': 'ID', // Id
	'matchedUser': 'Matched user', // Napojený uživatel
	'birthDate': 'Date of birth', // Datum narození
	'phoneNumber': 'Phone number', // Telefon
	'birthNumber': 'Personal Identification number', // Rodné číslo
	'primaryNationality': 'Nationality', // Národnost
	'deletedWhen': 'Deleted', // Smazáno
	'isSystemAdmin': 'System administrator', // Systémový administrátor
	'isSubmissionAdmin': 'Submission administrator', // Správce podání
	'submissionDateRange': 'Submission from - to', // Podání od - do
	'distributionPeriodId': 'Distribution period', // Distribuční období
	'originalTitle': 'Original title', // Původní titul
	'cinemaAttendanceRecordCount': 'No. of records - attendance', // Poč. zázn. - návštěvnost
	'broadcastRecordCount': 'No. of records - broadcasting', // Poč. zázn. - vysílání
	'saleRecordCount': 'No. of records - sale', // Poč. zázn. - prodej
	'cinemaAttendance': 'Cinema attendance', // Návštěvnost kin
	'mainArtist': 'Main artist', // Hlavní umělec
	'submissionOnBehalfOf': 'Submission on behalf of', // Podání za
	'releaseDate': 'Premiere', // Premiéra
	'broadcastTime': 'Broadcast time', // Čas vysílání
	'importedFromExcel': 'Imported from Excel', // Naimportováno z Excelu
	'rowId': 'Row number', // Číslo řádku
	'recordingName': 'Recording name', // Název díla
	'countryId': 'Country', // Země
	'sharePct': 'Share', // Podíl
	'creatorRoleId': 'Role', // Role
	'ufdAttendance': 'Attendance by UFD', // Návštěvnost dle UFD
	'producerName': 'Producer name', // Název výrobce
	'currencyId': 'Currency', // Měna
	'affirmationRecordingTypeId': 'Recording type', // Druh záznamu
	'affirmationRecordingType': 'Recording type', // Druh záznamu
	'broadcastStartTime': 'Start time of broadcast', // Čas zahájení vysílání
	'physicalSaleIncome': 'Income from physical media sales (excl. VAT)', // Příjem za fyzický prodej nosičů bez DPH
	'digitalSaleIncome': 'Income from digital sales (excl. VAT)',
	'addedBy': 'Added by', // Přidal(a)
	'addedWhen': 'Added', // Přidáno
	'deletedBy': 'Deleted', // Smazal(a)
	'languageId': 'Language', // Jazyk
	'altTitle.tabularCatalog': 'Alternative title', // Alternativní název
	'pinDob': 'PIN/DOB', // RČ/dat.nar.
	'runtimeMin.tabularCatalog': 'Runtime minutes', // Stopáž minuty
	'runtimeSec.tabularCatalog': 'Runtime seconds', // Stopáž vteřiny
	'recordingTypeId.tabularCatalog': 'Audio / video clip', // Audio / videoklip
	'licenceSharePct.tabularCatalog': 'Coproduction', // Koprodukce
	'mainArtist.tabularCatalog': 'Main performer', // Hlavní interpret
	'performer1Name.tabularCatalog': 'Performer1', // Interpret1
	'performer1SharePct.tabularCatalog': 'Share - performer1', // Podíl - interpret1
	'performer1Performance.tabularCatalog': 'Performance - performer1', // Výkon - interpret1
	'performer2Name.tabularCatalog': 'Performer2', // Interpret2
	'performer2SharePct.tabularCatalog': 'Share - performer2', // Podíl - interpret2
	'performer2Performance.tabularCatalog': 'Performance - performer2', // Výkon - interpret2
	'performer3Name.tabularCatalog': 'Performer3', // Interpret3
	'performer3SharePct.tabularCatalog': 'Share - performer3', // Podíl - interpret3
	'performer3Performance.tabularCatalog': 'Performance - performer3', // Výkon - interpret3
	'performer4Name.tabularCatalog': 'Performer4', // Interpret4
	'performer4SharePct.tabularCatalog': 'Share - performer4', // Podíl - interpret4
	'performer4Performance.tabularCatalog': 'Performance - performer4', // Výkon - interpret4
	'performer5Name.tabularCatalog': 'Performer5', // Interpret5
	'performer5SharePct.tabularCatalog': 'Share - performer5', // Podíl - interpret5
	'performer5Performance.tabularCatalog': 'Performance - performer5', // Výkon - interpret5
	'authorMusic.tabularCatalog': 'Composer', // Autor hudby
	'authorLyrics.tabularCatalog': 'Lyricist', // Autor textu
	'genreId.tabularCatalog': 'Genre', // Žánr
	'productionYear.tabularCatalog': 'Year of production', // Rok výroby
	'releaseYear.tabularCatalog': 'Year of first release', // Rok prvního vydání
	'recordingCountryId.tabularCatalog': 'Country or production', // Země výroby
	'licenceFromDate.tabularCatalog': 'Licence validity 1', // Platnost licence 1
	'licenceToDate.tabularCatalog': 'Licence validity 2', // Platnost licence 2
	'aiGenerated.tabularCatalog': 'AI-generated music', // Hudba generovaná AI
	'mainArtist.recordingProtocol': 'Main artist/ensemble', // Hlavní umělec/skupina
	'releaseYear.recordingProtocol': 'Year of first release/publication', // Rok prvního vydání/zveřejnění
	'productionYear.recordingProtocol': 'Year of origin', // Rok vzniku
	'recordingCountryId.recordingProtocol': 'Country of origin', // Země vzniku
	'genreId': 'Recording genre', // Druh nahrávky
	'recordingCountryId': 'Country of recording origin', // Země vzniku nahrávky
	'performerTotalShare': 'Total share (%)', // Celkový podíl (%)
	'isMa': 'Main artist', // Hlavní umělec
	'isMainArtistMember': 'Main artist', // Hlavní umělec
	'producerCodes': 'Producer codes', // Kódy výrobce
	'shareOrRole': 'Share / role', // Podíl / role

	'runtime_minutes': 'Runtime (minutes)', // Stopáž (v minutách)
	'runtime.affirmationBroadcast': 'Runtime (minutes)', // Stopáž (v minutách)
	'performance': 'Performance', // Výkon

	producers: 'Producers',
	correctionReason: 'Justification for correction/addition',
	document_name: 'Document name',
	document_no: 'Document no',
	closure_id: 'Closure ID',
	amount: 'Amount',

	last_submitted: 'Last submitted',
	period: 'Period',
	withholding_tax: 'Withholding tax',
	net_amount: 'Net amount',

	intergram_comment: 'Intergram comment',
	label_name: 'Label name',
	modified: 'Modified',
	newly_added: 'Newly added',
};

const l10n = {
	phrases,
	columnTexts
};

export default l10n;
